import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import {
  FormAlert,
  FormGroup,
  NewInputText,
  parseFinalFormErrors,
} from '@saucelabs/sl-component-form';
import { Row, Col } from '@saucelabs/sl-component-grid';
import Button from '@saucelabs/sl-component-buttons';

const ResetPasswordForm = ({ resetPassword, verifier }) => (
  <Form
    onSubmit={(values) => (
      resetPassword({ ...values, verifier })
        // react-final-form requires forms to resolve with no value on success
        .then(() => null)
        .catch(({ response }) => (
          parseFinalFormErrors(
            {},
            (response.data.errors && Object.values(response.data.errors)[0]) ||
              response.data.message,
          )
        ))
    )}
    render={({ form, handleSubmit }) => {
      const { error, submitError, submitting } = form.getState();

      return (
        <form onSubmit={handleSubmit}>
          <FormAlert type="danger">{error || submitError}</FormAlert>
          <Row>
            <Col xs>
              <Field
                autoFocus
                className="form-control"
                component={NewInputText}
                name="password"
                placeholder="New password"
                type="password"
              />
            </Col>
          </Row>
          <Row>
            <Col xs>
              <Field
                className="form-control"
                component={NewInputText}
                name="password_confirm"
                placeholder="Confirm new password"
                type="password"
              />
            </Col>
          </Row>
          <FormGroup>
            <Button
              block
              category="action"
              disabled={submitting}
              type="submit"
              withArrow
            >
              Reset Password
            </Button>
          </FormGroup>
        </form>
      );
    }}
  />
);

ResetPasswordForm.propTypes = {
  resetPassword: PropTypes.func.isRequired,
  verifier: PropTypes.string.isRequired,
};

export default ResetPasswordForm;
export { ResetPasswordForm };
